// Added By Farhan Khan Khan on 24-Dec-2025
import React, { useState, useEffect } from "react";
import { Badge, Button, Card, Col, Container, Row } from "react-bootstrap";
import Confirm from "../Confirm";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import solisPowerApi from "../../api/solisPowerApi";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import FilesCreate from "../file/FilesCreate";
import RelatedListFiles from "../file/RelatedListFiles";
import Path from "../common/Path";
import moment from "moment";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";
import * as constants from "../../constants/CONSTANT";
import PubSub from "pubsub-js";
import jwt_decode from "jwt-decode";
import Helmet from "react-helmet";
import Main from "../layout/Main";
import Image from "react-bootstrap/Image";
import Permissionhelper from "../common/Permissionhelper";
import { formatDate, formatDateForCreatedDate, formatDateForView, getUserDetails } from "../../utils/helper";
import PERMISSIONS from "../../constants/permissions";

const BrandView = (props) => {
  const userInfo = getUserDetails();
  const location = useLocation();
  const navigate = useNavigate();
  const [brand, setBrand] = useState(location.state ? location.state : {});
  const [data, setData] = useState([]);
  const [modalShow, setModalShow] = useState(false);

  useEffect(() => {
    fetchBrand();
  }, []);

  const fetchBrand = () => {
    if (!brand.id && location.hasOwnProperty("pathname") && location.pathname.split("/").length >= 3) {
      brand.id = location.pathname.split("/")[2];
    }

    async function initBrand() {
      try {
        let result = await solisPowerApi.fetchBrandById(brand.id);

        if (result) {
          setBrand(result);
        } else {
          setBrand({});
        }
      } catch (error) {
        console.error("Error fetching brand:", error);
      }
    }

    initBrand();
  };

  const deleteBrand = async () => {
    const result = await solisPowerApi.deleteBrand(location?.state.id ? location?.state.id : brand?.id);
    if (result) {
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Deleted ",
        message: "Record Deleted successfully",
      });
      navigate(`/brands`);
    }
  };

  const editBrand = () => {
    navigate(`/brands/${brand.id}/e`, { state: brand });
  };

  return (
    <Main>
      <Container>
        {brand && (
          <>
            {modalShow && (
              <Confirm
                show={modalShow}
                onHide={() => setModalShow(false)}
                deleteProduct={deleteBrand}
                title="Confirm delete?"
                message="You are going to delete the record. Are you sure?"
                table="Brand"
              />
            )}
            <Row className="view-form">
              <Col lg={11} className="pb-3 pt-2">
                <Link className="nav-link" to="/brands">
                  Home <i className="fa-solid fa-chevron-right"></i>{" "}
                  <div style={{ color: "#23468c", display: "inline" }}>
                    Brand
                  </div>
                </Link>
              </Col>
              <Col></Col>
            </Row>
            <Row className="view-form gx-5 mx-auto">
              <Col lg={9}>
                <Row className="view-form-header bg-custom align-items-center">
                  <Col lg={8}>
                    Brand
                    <h5>{brand.name}</h5>
                  </Col>
                  <Col lg={4} className="d-flex justify-content-end">
                    <>
                      {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_PRODUCT].some(permission => {
                        return userInfo?.permissions.map(p => p.name).includes(permission);
                      }) && (
                          <Button
                            size="sm"
                            className="btn-edit mx-2"
                            onClick={() => editBrand(true)}
                          >
                            <i className="fa-regular fa-pen-to-square"></i>
                          </Button>
                        )}
                      {[PERMISSIONS.DELETE_ALL, PERMISSIONS?.DELETE_PRODUCT].some(permission => {
                        return userInfo?.permissions.map(p => p.name).includes(permission);
                      }) && (
                          <Button
                            className="btn-sm"
                            variant="danger"
                            onClick={() => setModalShow(true)}
                          >
                            <i className="fa fa-trash-o"></i>
                          </Button>
                        )}
                    </>
                  </Col>
                </Row>

                <Row className="py-3 ibs-edit-form">
                  <Col lg={6}>
                    <label>Brand Name</label>
                    <span>{brand.name}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Make Type</label>
                    <span>{brand.make_type}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Section Type</label>
                    <span>{brand.section_type}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Status</label>
                    <span>
                      <Badge bg={brand.status === "Active" ? "success" : "secondary"}>
                        {brand.status}
                      </Badge>
                    </span>
                  </Col>
                  <Col lg={12}>
                    <label>Created Date</label>
                    <span>
                      {formatDateForView(brand?.createddate || "")}
                    </span>
                  </Col>
                </Row>
              </Col>
            </Row>
          </>
        )}
      </Container>
    </Main>
  );
};

export default BrandView;
